import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "p-3" };
const _hoisted_2 = {
    key: 0,
    class: "text-overview"
};
const _hoisted_3 = {
    key: 1,
    class: "text-overview"
};
const _hoisted_4 = { class: "mt-2 d-flex flex-row gap-16px" };
const _hoisted_5 = { class: "d-flex flex-row gap-16px w-100" };
const _hoisted_6 = { class: "flex-1" };
const _hoisted_7 = { class: "flex-1 w-50" };
const _hoisted_8 = { class: "d-flex flex-column flex-grow-1 mt-1" };
const _hoisted_9 = { class: "d-flex flex-row gap-16px w-100" };
const _hoisted_10 = { class: "flex-1" };
const _hoisted_11 = { class: "flex-1 w-50" };
const _hoisted_12 = { class: "px-1" };
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_14 = { class: "d-flex align-items-center" };
const _hoisted_15 = ["src"];
const _hoisted_16 = {
    class: "fw-semibold",
    style: { "font-size": "0.85em" }
};
const _hoisted_17 = { class: "input-group w-auto ms-3" };
const _hoisted_18 = ["value", "onInput"];
const _hoisted_19 = {
    key: 0,
    class: "d-flex justify-content-start ms-2"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = { class: "d-flex flex-row gap-16px w-100" };
const _hoisted_22 = { class: "flex-1" };
const _hoisted_23 = { class: "flex-1 w-50" };
import ButtonComponent from '../components/Button.vue';
import InputComponent from '../components/Input.vue';
import TextAreaComponent from '../components/TextArea.vue';
import ImgUploadComponent from '../components/ImageUpload/ImgUploadComponent.vue';
import LanguageComponent from '../components/Language.vue';
import ValidateModal from '../components/ValidateModal.vue';
import OfferList from '../components/OfferList.vue';
import Loading from 'vue-loading-overlay';
import { useToast } from 'vue-toast-notification';
import { ref, onMounted, watch, onBeforeMount } from 'vue';
import { container as WidgetContainerModal, closeById, pushModal } from "jenesius-vue-modal";
import { formatDate, parseDateFromString } from '../lib/utils';
import axios from 'axios';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue-loading-overlay/dist/css/index.css';
import RocketIcon from '../assets/icons/rocket-takeoff.png';
import GiftIcon from '../assets/icons/gift.png';
import CalendarXIcon from '../assets/icons/calendar2-x.png';
import SlashCircleIcon from '../assets/icons/slash-circle.png';
import ArrowDownIcon from '../assets/icons/arrow-down.png';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditCampaign',
    props: {
        campaignId: { type: String },
        router: { type: Object },
        baseUrl: { type: String },
        languageJson: { type: Array },
        locked: { type: Boolean, default: false }
    },
    emits: ['status', 'locked'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const $toast = useToast();
        const router = ref(props.router);
        const token = ref('');
        const isLoading = ref(false);
        const getError = ref(null);
        const langCode = ref('it');
        const is_rtl = ref(false);
        const imagesData = ref([]);
        const status = ref('');
        const updatedByName = ref('');
        const updatedAt = ref('');
        const validateText = ref([]);
        const itineraryTypesData = ref([]);
        const labelData = ref([]);
        const planSteps = ref([]);
        const selecetedOffers = ref([]);
        const flagImgUpload = ref(true);
        const document = ref({});
        const languageData = ref(props.languageJson.filter(val => !val.is_sign_language && !val.tours_only));
        const setPlanSteps = () => {
            planSteps.value = [
                { label: "Lancio Promozione", icon: RocketIcon, date: document.value.activityStarts },
                { label: "Inizio Campagna", icon: GiftIcon, date: document.value.campaignStarts },
                { label: "Fine Campagna", icon: CalendarXIcon, date: document.value.campaignEnds },
                { label: "Termine validità Voucher", icon: SlashCircleIcon, date: document.value.activityEnds }
            ];
        };
        function hideImgUpload() {
            flagImgUpload.value = !flagImgUpload.value;
        }
        // campi multilingua
        const MULTILANGFIELDS = ['title', 'description', 'point'];
        const initializeDocument = () => {
            document.value = {}; // reset
            MULTILANGFIELDS.forEach(field => {
                document.value[field] = {};
                languageData.value.forEach(lang => {
                    document.value[field][lang.lang_code] = '';
                });
            });
        };
        const handleLang = (payload) => {
            labelData.value = payload;
            const lang = props.languageJson.find(l => l.name === payload)?.lang_code;
            const rtl = props.languageJson.find(l => l.name === payload)?.is_rtl;
            if (lang)
                langCode.value = lang;
            if (rtl !== undefined)
                is_rtl.value = rtl;
        };
        const onOffersOrderChange = (payload) => {
            console.log('offersOrderChange', payload);
        };
        const onShowModal = async () => {
            const modal = await pushModal(ValidateModal, {
                modalTitle: 'Avvertimento',
                modalContent: validateText.value
            });
            modal.on('confirm', () => {
                closeById(modal.id);
            });
        };
        const handleUpload = (payload) => {
            imagesData.value = payload;
        };
        const handleGoBack = () => {
            router.value.go(-1);
        };
        const updateStepDate = (index, value) => {
            const date = parseDateFromString(value);
            planSteps.value[index].date = date.toISOString();
            // aggiorno anche document.value
            switch (index) {
                case 0:
                    document.value.activityStarts = date.toISOString();
                    break;
                case 1:
                    document.value.campaignStarts = date.toISOString();
                    break;
                case 2:
                    document.value.campaignEnds = date.toISOString();
                    break;
                case 3:
                    document.value.activityEnds = date.toISOString();
                    break;
            }
        };
        const fetchDataById = async () => {
            isLoading.value = true;
            try {
                if (!props.campaignId.includes('new')) {
                    const response = await axios.get(`${props.baseUrl}/v1/private/campaigns/${props.campaignId}`, {
                        headers: { Authorization: `Bearer ${token.value}`, 'Accept-Language': '' }
                    });
                    document.value = { ...document.value, ...response.data };
                    status.value = document.value.status.name;
                    console.log('document', document.value);
                    // aggiorno textfields con valori dal backend
                    if (document.value.images?.length) {
                        imagesData.value = document.value.images;
                    }
                    if (document.value.textFields?.length) {
                        document.value.textFields.forEach(field => {
                            const key = field.key;
                            // inizializzo il campo se non esiste
                            if (!document.value[key]) {
                                document.value[key] = {};
                            }
                            document.value[key][field.languageCode] = field.value;
                        });
                    }
                }
                if (status.value === 'PUBLISHED')
                    document.value.locked = true;
                setPlanSteps();
                emit('status', status.value);
                emit('locked', document.value.locked);
            }
            catch (err) {
                console.error(err);
                getError.value = true;
            }
            finally {
                isLoading.value = false;
            }
        };
        const validateData = () => {
            const errors = [];
            props.languageJson.forEach(lang => {
                if (!lang.required)
                    return;
                MULTILANGFIELDS.forEach(field => {
                    if (!document.value[field]?.[lang.lang_code]) {
                        errors.push(`<b>${field} in ${lang.name}</b>`);
                    }
                });
            });
            return errors;
        };
        const buildTextFieldsFromDocument = () => {
            const textFields = [];
            Object.keys(document.value).forEach(field => {
                if (MULTILANGFIELDS.includes(field)) {
                    Object.entries(document.value[field]).forEach(([lang, text]) => {
                        textFields.push({
                            key: field,
                            languageCode: lang,
                            value: text
                        });
                    });
                }
            });
            return textFields;
        };
        const handleEdit = async (statusOverride) => {
            validateText.value = validateData();
            isLoading.value = true;
            if (validateText.value.length) {
                onShowModal();
                return;
            }
            let method = 'put';
            let message = 'Campagna aggiornata con successo';
            if (props.campaignId.includes('new')) {
                method = 'post';
                message = 'Campagna creata con successo';
            }
            try {
                const textFields = buildTextFieldsFromDocument();
                const doc = {
                    status: statusOverride ?? document.value.status.name,
                    name: document.value.title['it'],
                    textFields: textFields,
                    offers: selecetedOffers.value.map(el => el.uuid),
                    activityStarts: document.value.activityStarts,
                    campaignStarts: document.value.campaignStarts,
                    campaignEnds: document.value.campaignEnds,
                    activityEnds: document.value.activityEnds,
                    images: imagesData.value.map(i => i.uuid)
                };
                const config = {
                    method,
                    url: `${props.baseUrl}/v1/private/campaigns/${props.campaignId.includes("new") ? "" : props.campaignId}`,
                    data: doc,
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                        "Content-Type": "application/json",
                    },
                };
                const res = await axios(config);
                if (res.status === 200 || res.status === 201) {
                    $toast.success(message, { position: "top-right" });
                    fetchDataById();
                }
            }
            catch (err) {
                console.error(err);
                $toast.error(err.response.data.title, { position: 'top-right' });
            }
            finally {
                isLoading.value = false;
            }
        };
        watch(() => props.locked, newValue => {
            document.value.locked = newValue;
        }, { immediate: true });
        onBeforeMount(() => {
            const data = localStorage.getItem('mi_cms-tokens');
            if (data)
                token.value = JSON.parse(data).access;
            initializeDocument();
        });
        onMounted(() => {
            if (props.languageJson.length) {
                languageData.value = props.languageJson.filter(val => val.is_sign_language === false && val.tours_only === false);
            }
            fetchDataById();
        });
        __expose({
            handleEdit
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                        _createVNode(_unref(Loading), {
                            active: isLoading.value,
                            "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((isLoading).value = $event)),
                            "can-cancel": false,
                            "is-full-page": true,
                            color: "#2D489D",
                            loader: "dots"
                        }, null, 8, ["active"])
                    ]))
                    : (getError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "No data to display"))
                        : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["create-route-panel-body flex-1", { 'disabled-state': document.value.locked }])
                    }, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(InputComponent, {
                                    modelValue: document.value.title[langCode.value],
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((document.value.title[langCode.value]) = $event)),
                                    title: "Titolo",
                                    "max-number": 50,
                                    placeholder: "Inserisci un titolo",
                                    "is-rtl": is_rtl.value
                                }, null, 8, ["modelValue", "is-rtl"])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title-form" }, " Stato ", -1)),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(ButtonComponent, {
                                        text: status.value === 'DRAFT' ? 'NON PUBBLICATA' : 'ATTIVA',
                                        type: "regular",
                                        isDisable: true,
                                        style: _normalizeStyle({ backgroundColor: status.value === 'DRAFT' ? '#7ef09d !important' : '#f38200 !important', color: '#2d489d' })
                                    }, null, 8, ["text", "style"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(TextAreaComponent, {
                                    modelValue: document.value.description[langCode.value],
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((document.value.description[langCode.value]) = $event)),
                                    title: "Descrizione",
                                    "max-number": 2000,
                                    rows: 8,
                                    placeholder: "Inserisci una descrizione della campagna",
                                    "is-rtl": is_rtl.value
                                }, null, 8, ["modelValue", "is-rtl"])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title-form" }, "Pianificazione", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planSteps.value, (step, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "text-center"
                                        }, [
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("img", {
                                                        src: step.icon,
                                                        alt: "",
                                                        class: "me-3 ms-2",
                                                        style: { "width": "17px", "height": "17px" }
                                                    }, null, 8, _hoisted_15),
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString(step.label), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("input", {
                                                        type: "date",
                                                        class: "form-control",
                                                        value: _unref(formatDate)(step.date),
                                                        onInput: (event) => updateStepDate(index, event.target.value)
                                                    }, null, 40, _hoisted_18)
                                                ])
                                            ]),
                                            (index < planSteps.value.length - 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _createElementVNode("img", {
                                                        src: _unref(ArrowDownIcon),
                                                        alt: "",
                                                        class: "my-1",
                                                        style: { "width": "14px", "height": "14px" }
                                                    }, null, 8, _hoisted_20)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createVNode(TextAreaComponent, {
                                    modelValue: document.value.point[langCode.value],
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((document.value.point[langCode.value]) = $event)),
                                    title: "Come raccogliere punti",
                                    "max-number": 500,
                                    rows: 4,
                                    placeholder: "Descrivi modalità di raccolta punti",
                                    "is-rtl": is_rtl.value
                                }, null, 8, ["modelValue", "is-rtl"]),
                                (flagImgUpload.value)
                                    ? (_openBlock(), _createBlock(ImgUploadComponent, {
                                        key: 0,
                                        token: token.value,
                                        baseUrl: props.baseUrl,
                                        initImages: imagesData.value,
                                        onHandleUpload: handleUpload
                                    }, null, 8, ["token", "baseUrl", "initImages"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(OfferList, {
                                    baseUrl: props.baseUrl,
                                    token: token.value,
                                    languageJson: languageData.value,
                                    campaignId: props.campaignId,
                                    onOnOffersOrderChange: onOffersOrderChange,
                                    onHideImgUpload: hideImgUpload
                                }, null, 8, ["baseUrl", "token", "languageJson", "campaignId"])
                            ])
                        ])
                    ], 2),
                    _createElementVNode("div", null, [
                        _createVNode(LanguageComponent, {
                            onHandleLang: handleLang,
                            onHandleModal: handleGoBack,
                            uuid: props.campaignId,
                            token: token.value,
                            languageJson: languageData.value,
                            baseUrl: props.baseUrl,
                            itineraryTypesData: itineraryTypesData.value,
                            status: status.value,
                            "updated-by": updatedByName.value,
                            "updated-at": updatedAt.value
                        }, null, 8, ["uuid", "token", "languageJson", "baseUrl", "itineraryTypesData", "status", "updated-by", "updated-at"])
                    ]),
                    _createVNode(_unref(WidgetContainerModal))
                ])
            ]));
        };
    }
});
